import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./teams.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "../../icon/icon.png";

const Teams: React.FC = () => {
  let base_url = process.env.REACT_APP_BASE_URL;
  let id_season = process.env.REACT_APP_ID_SEASON;
  let coffee_tools = new coffeeTools();

  const [showProgessBar, setShowProgessBar] = useState(true);
  const [teams, setTeams] = useState([]);
  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    // let coffee_tools = new coffeeTools();

    // console.log(coffee_tools.test(123));
  }, []);

  var controller = (() => {
    function getTeams(callback) {
      fetch(base_url + "/sports/seasons/participants/latest", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_season: id_season
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    return {
      getTeams: (callback) => getTeams(callback)
    };
  })();

  let view = (() => {
    let dom_obj = {
      teams_teams: "js__teams_teams",
      teams_teams_title: "js__teams_teams_title"
    };

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";
      coffee_tools.createSectionTitle(title, container);
    }

    // teams
    function showTeams(response) {
      console.log("teams", response);
      let teams_to_display = [];
      response.items_team.forEach((team) => {
        teams_to_display.push({
          id_team: team.id,
          team_logo: base_url + team.full_url_logo,
          team_name: team.name,
          team_color: team.team_color
        });
      });

      setTeams(teams_to_display);
    }

    return {
      dom_obj: dom_obj,
      createSectionTitles: (title, dom_obj_id) =>
        createSectionTitles(title, dom_obj_id),
      showTeams: (response) => showTeams(response)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        console.log("Menu started");
        setupEventListeners();
        // teams
        page_view.createSectionTitles(
          "Equipos LNBP",
          page_view.dom_obj.teams_teams_title
        );
        page_controller.getTeams(page_view.showTeams);

        // hide progress bar
        setShowProgessBar(false);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <section id='js__teams_teams'>
          <span id='js__teams_teams_title'></span>
          <IonList>
            {teams.map((team) => {
              return (
                <IonItem
                  className='team_list ion-no-padding'
                  key={team.id_team}
                  routerLink={"/teamdetails?team_id=" + team.id_team}
                >
                  <div style={{ backgroundColor: team.team_color }}>
                    <img
                      src={team.team_logo}
                      alt={team.team_name}
                    />
                  </div>
                  <IonLabel>
                    <h2>{team.team_name}</h2>
                    <p>{team.team_city}</p>
                  </IonLabel>
                </IonItem>
              );
            })}
          </IonList>
        </section>
      </IonContent>
    </IonPage>
  );
};

export default Teams;
